import { useParams } from 'react-router-dom';
import { CertificatesCourseView } from '@/views/CertificatesView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const CertificatesCoursePage = () => {
  const { courseId } = useParams<{ courseId: string }>();

  if (!courseId) {
    return null;
  }

  return (
    <MainLayout headerTitle="Certificates">
      <CertificatesCourseView courseId={Number(courseId)} />
    </MainLayout>
  );
};

export default CertificatesCoursePage;
